// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon.delete {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  height: 8px;
  width: 8px;
  min-height: 8px;
  min-width: 8px;
  max-height: 8px;
  max-width: 8px;
  cursor: pointer;
}

.icon.arrow-downward {
  color: #999;
  border-style: solid;
  border-width: 4px 4px 0;
  border-color: #999 transparent transparent;
  content: '';
  transition: transform 0.2s linear;
  cursor: pointer;
  position: absolute;
  right: 12px;
}

.icon.arrow-downward.active {
  transform: rotate(180deg);
}

.vue-select {
  position: relative;
}

.vue-select[aria-disabled='true'] {
  background-color: rgba(239, 239, 239);
}

.vue-select[aria-disabled='true'] * {
  cursor: not-allowed;
}

.vue-select[aria-disabled='true'] input {
  cursor: not-allowed;
}

.vue-select-header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.vue-select-header .icon.loading,
.vue-select-header .icon.arrow-downward {
  margin-right: 4px;
}

.vue-tags {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 2px;
  min-height: calc(1rem + 4px);
  user-select: none;
}

.vue-tags.collapsed {
  flex-wrap: nowrap;
  overflow: auto;
}

.vue-tag {
  display: none;
  align-items: center;
  justify-content: center;
  list-style-type: none;
  border-radius: 4px;
  background-color: #999;
  padding: 0 4px;
  margin: 2px;
  min-height: 1rem;
  font-size: 0.8rem;
}

.vue-tag span {
  margin-right: 4px;
}

.vue-tag.selected {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #999;
  border-radius: 4px;
  padding: 0 4px;
  font-size: 0.8rem;
}

.vue-tags[data-removable='false'] .vue-tag.selected img:hover {
  cursor: not-allowed;
}

.vue-select-input-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.vue-select-input-wrapper .icon.loading {
  margin-right: 4px;
}

.vue-input {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  border: none;
  outline: none;
  max-width: 100%;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.vue-input > div {display: flex;align-items: center;padding: 2px 0;}
.vue-input > div .flag {margin: 0;}

.vue-select[data-is-focusing='false'][aria-disabled='false'] .vue-input input,
input[readonly] {
  cursor: default;
}

.vue-input input {
  border: none;
  outline: none;
  width: 100%;
  min-width: 0;
  font-size: 18px;
  padding: 0 12px;
  height: 44px;
  background: transparent;
}

.vue-input input[disabled] {
  background-color: rgba(239, 239, 239);
}

.vue-input input[readonly] {
  background-color: unset;
}

.vue-select-header .vue-input input[disabled] {
  background-color: unset;
}

.vue-dropdown {
  display: none;
  position: absolute;
  background-color: white;
  z-index: 1;
  overflow-y: auto;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  left: -1px;
  box-sizing: content-box;
  border: 1px solid #f2f2f2;
  background: #fcfcfc;
  list-style-type: none;
  border-radius: 5px;
}

.vue-select[aria-expanded='true'] .vue-dropdown {
  display: unset;
}

.vue-dropdown[data-visible-length='0'] {
  border: none;
}

.vue-dropdown-item {
  list-style-type: none;
  padding: 10px 15px;
  cursor: pointer;
  min-height: 1rem;
  font-size: 16px;
}

.vue-dropdown-item > div {display: flex;align-items: center;}
.vue-dropdown-item > div .normal-flag {margin: 0;}

.vue-dropdown-item.highlighted {
  background-color: #f5f5f5;
}

.vue-dropdown-item.disabled {
  background-color: rgba(239, 239, 239);
  cursor: not-allowed;
}

.vue-dropdown-item.selected {
  background-color: #ff3347;
  color: #fff;
}

.vue-dropdown-item.selected.highlighted {
  background-color: #f53145;
  color: #fff;
}

.vue-dropdown[data-removable='false'] .vue-dropdown-item.selected:hover {
  cursor: not-allowed;
}

.vue-dropdown[data-addable='false'][data-multiple='true'] .vue-dropdown-item:not(.selected):hover {
  cursor: not-allowed;
}

.icon.loading {
  display: inline-block;
  position: relative;
  width: 8px;
  min-width: 8px;
  height: 8px;
  min-height: 8px;
}

.icon.loading div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  border: 1px solid #999;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: loading 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #999 transparent transparent transparent;
}

.icon.loading div:nth-child(1) {
  animation-delay: -0.08s;
}
.icon.loading div:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.inline-flex {
  display: inline-flex;
}

.vue-select[aria-expanded='true'].direction-bottom {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.vue-select[aria-expanded='true'].direction-top {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.vue-select.direction-top .vue-dropdown {
  bottom: 100%;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  margin-bottom: 5px;
}

.vue-select.direction-bottom .vue-dropdown {
  top: 100%;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./assets/vue_apps/quote-form/src/css/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,WAAW;EACX,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA,kBAAkB,aAAa,CAAC,mBAAmB,CAAC,cAAc,CAAC;AACnE,wBAAwB,SAAS,CAAC;;AAElC;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B,aAAa,CAAC,mBAAmB,CAAC;AAC5D,uCAAuC,SAAS,CAAC;;AAEjD;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2DAA2D;EAC3D,sDAAsD;AACxD;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;AACjB","sourcesContent":[".icon.delete {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: none;\n  height: 8px;\n  width: 8px;\n  min-height: 8px;\n  min-width: 8px;\n  max-height: 8px;\n  max-width: 8px;\n  cursor: pointer;\n}\n\n.icon.arrow-downward {\n  color: #999;\n  border-style: solid;\n  border-width: 4px 4px 0;\n  border-color: #999 transparent transparent;\n  content: '';\n  transition: transform 0.2s linear;\n  cursor: pointer;\n  position: absolute;\n  right: 12px;\n}\n\n.icon.arrow-downward.active {\n  transform: rotate(180deg);\n}\n\n.vue-select {\n  position: relative;\n}\n\n.vue-select[aria-disabled='true'] {\n  background-color: rgba(239, 239, 239);\n}\n\n.vue-select[aria-disabled='true'] * {\n  cursor: not-allowed;\n}\n\n.vue-select[aria-disabled='true'] input {\n  cursor: not-allowed;\n}\n\n.vue-select-header {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.vue-select-header .icon.loading,\n.vue-select-header .icon.arrow-downward {\n  margin-right: 4px;\n}\n\n.vue-tags {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 2px;\n  min-height: calc(1rem + 4px);\n  user-select: none;\n}\n\n.vue-tags.collapsed {\n  flex-wrap: nowrap;\n  overflow: auto;\n}\n\n.vue-tag {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  list-style-type: none;\n  border-radius: 4px;\n  background-color: #999;\n  padding: 0 4px;\n  margin: 2px;\n  min-height: 1rem;\n  font-size: 0.8rem;\n}\n\n.vue-tag span {\n  margin-right: 4px;\n}\n\n.vue-tag.selected {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #999;\n  border-radius: 4px;\n  padding: 0 4px;\n  font-size: 0.8rem;\n}\n\n.vue-tags[data-removable='false'] .vue-tag.selected img:hover {\n  cursor: not-allowed;\n}\n\n.vue-select-input-wrapper {\n  position: relative;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.vue-select-input-wrapper .icon.loading {\n  margin-right: 4px;\n}\n\n.vue-input {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 4px;\n  border: none;\n  outline: none;\n  max-width: 100%;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.vue-input > div {display: flex;align-items: center;padding: 2px 0;}\n.vue-input > div .flag {margin: 0;}\n\n.vue-select[data-is-focusing='false'][aria-disabled='false'] .vue-input input,\ninput[readonly] {\n  cursor: default;\n}\n\n.vue-input input {\n  border: none;\n  outline: none;\n  width: 100%;\n  min-width: 0;\n  font-size: 18px;\n  padding: 0 12px;\n  height: 44px;\n  background: transparent;\n}\n\n.vue-input input[disabled] {\n  background-color: rgba(239, 239, 239);\n}\n\n.vue-input input[readonly] {\n  background-color: unset;\n}\n\n.vue-select-header .vue-input input[disabled] {\n  background-color: unset;\n}\n\n.vue-dropdown {\n  display: none;\n  position: absolute;\n  background-color: white;\n  z-index: 1;\n  overflow-y: auto;\n  width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  left: -1px;\n  box-sizing: content-box;\n  border: 1px solid #f2f2f2;\n  background: #fcfcfc;\n  list-style-type: none;\n  border-radius: 5px;\n}\n\n.vue-select[aria-expanded='true'] .vue-dropdown {\n  display: unset;\n}\n\n.vue-dropdown[data-visible-length='0'] {\n  border: none;\n}\n\n.vue-dropdown-item {\n  list-style-type: none;\n  padding: 10px 15px;\n  cursor: pointer;\n  min-height: 1rem;\n  font-size: 16px;\n}\n\n.vue-dropdown-item > div {display: flex;align-items: center;}\n.vue-dropdown-item > div .normal-flag {margin: 0;}\n\n.vue-dropdown-item.highlighted {\n  background-color: #f5f5f5;\n}\n\n.vue-dropdown-item.disabled {\n  background-color: rgba(239, 239, 239);\n  cursor: not-allowed;\n}\n\n.vue-dropdown-item.selected {\n  background-color: #ff3347;\n  color: #fff;\n}\n\n.vue-dropdown-item.selected.highlighted {\n  background-color: #f53145;\n  color: #fff;\n}\n\n.vue-dropdown[data-removable='false'] .vue-dropdown-item.selected:hover {\n  cursor: not-allowed;\n}\n\n.vue-dropdown[data-addable='false'][data-multiple='true'] .vue-dropdown-item:not(.selected):hover {\n  cursor: not-allowed;\n}\n\n.icon.loading {\n  display: inline-block;\n  position: relative;\n  width: 8px;\n  min-width: 8px;\n  height: 8px;\n  min-height: 8px;\n}\n\n.icon.loading div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  border: 1px solid #999;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  animation: loading 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #999 transparent transparent transparent;\n}\n\n.icon.loading div:nth-child(1) {\n  animation-delay: -0.08s;\n}\n.icon.loading div:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.inline-flex {\n  display: inline-flex;\n}\n\n.vue-select[aria-expanded='true'].direction-bottom {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vue-select[aria-expanded='true'].direction-top {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.vue-select.direction-top .vue-dropdown {\n  bottom: 100%;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  margin-bottom: 5px;\n}\n\n.vue-select.direction-bottom .vue-dropdown {\n  top: 100%;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
